import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { NewStoryService } from '../new';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class DesigningService {
  private baseUrl = environment.API;
  designingProgress = 0;
  isUploadProgressShowing = false;

  constructor(
    private http: HttpClient,
    private uploadService: NewStoryService,
    private router: Router,
    ) {}

  retrieveDesignProgress() {
    const url = `${this.baseUrl}/stories/${this.uploadService.storyId}/`;
    return this.http.get(url).pipe(map(resp => {
      return resp['design_progress'];
    }));
  }
  updateNavigation() {
    if (this.isUploadProgressShowing && this.designingProgress === 100) {
      this.resetProgress();
      this.navigateToBook();
    }
  }
  resetProgress() {
    this.designingProgress = 0;
    this.isUploadProgressShowing = false;
  }
  navigateToBook() {
    this.router.navigate([`/stories/${this.uploadService.storyId}`]);
    this.uploadService.storyId = undefined;
    this.resetProgress();
  }
  updateDesignProgress() {
    if (this.designingProgress < 100) {
      this.retrieveDesignProgress().subscribe(
        progress => {
          this.designingProgress = progress;
          if (progress < 100) {
            setTimeout(() => {
              this.updateDesignProgress();
            }, 200);
          } else {
            this.updateNavigation();
          }
        },
        () => {
          setTimeout(() => {
            this.updateDesignProgress();
          }, 1000);
        });
    }
  }
}
